import { ContentVariants, SidesheetItem, GetWorkOrder_V1Query } from '@lichtblick/types';

import { formatName } from './formatName';

export const createContent = (
  data: GetWorkOrder_V1Query['getWorkOrder_V1']['data'],
  t: (key: string) => string,
): SidesheetItem[] => {
  if (!data) {
    return [];
  }

  const customersContacts =
    data.customers
      ?.flatMap((customer) => [
        {
          value: customer.customer?.mobilePhoneNumber ?? '',
          subtitle: t('common:sidebar.customer'),
        },
        {
          value: customer.customer?.phoneNumber ?? '',
          subtitle: t('common:sidebar.customer'),
        },
      ])
      .filter((el) => el.value) ?? [];

  // const teamMembersContacts =
  //   data.constructedByTeams
  //     ?.flatMap(
  //       (team) =>
  //         team.members
  //           ?.flatMap((member) => [
  //             {
  //               value: member.mobilePhone ?? '',
  //               subtitle: formatName(member),
  //             },
  //             {
  //               value: member.phone ?? '',
  //               subtitle: formatName(member),
  //             },
  //           ])
  //           .filter((el) => el?.value) ?? [],
  //     )
  //     .filter((el) => el.value) ?? [];

  return [
    {
      type: 'customer' as ContentVariants,
      items: data.customers?.map((customer) => ({
        label: customer.customer ? formatName(customer.customer) : '',
        value: customer.customer ? customer.customer.id.toString() : '',
      })),
    },
    {
      type: 'eaasId' as ContentVariants,
      items: data.eaasId
        ? [
            {
              label: data.eaasId,
              value: data.eaasId,
            },
          ]
        : [],
    },
    {
      type: 'product' as ContentVariants,
      items: data.product?.name ? [{ value: data.product.name }] : [],
    },
    {
      type: 'address' as ContentVariants,
      items: data.address
        ? [
            {
              label: `${data.address.street} ${data.address.number}
          ${data.address.zipCode} ${data.address.city}`,
              value: `${data.address.coordinates?.latitude},${data.address.coordinates?.longitude}`,
            },
          ]
        : [],
    },
    // {
    //   type: 'phone' as ContentVariants,
    //   items: [...customersContacts, ...teamMembersContacts],
    // },
    {
      type: 'phone' as ContentVariants,
      items: [...customersContacts],
    },
    {
      type: 'email' as ContentVariants,
      items:
        data.customers
          ?.map((customer) => ({
            value: customer.customer?.eMail ?? '',
          }))
          .filter((el) => el) ?? [],
    },
    // {
    //   type: 'documents' as ContentVariants,
    //   items: data.medias?.map((media) => ({
    //     value: media.uri ? media.uri.toString() : '',
    //     label: media.fileName ?? media.id.toString(),
    //   })),
    // },
    {
      type: 'projectManager' as ContentVariants,
      items: [
        {
          label: formatName({ firstName: data.projectManager?.firstName, lastName: data.projectManager?.lastName }),
          subtitle: 'Project Manager',
          value: data.projectManager?.eMail ?? '',
        },
      ],
    },
  ];
};
